'use strict';

var formulaObj = null;

var formula = function formula() {
    var blurFields = [];
    var fieldsOutOfTable = [];
    var fieldsTotal = [];

    var supportedFunctions = ["SUM", "AVG", "MAX", "MIN", "COUNT"];
    supportedFunctions.getRegex = function (addFields) {
        var functionsPattern = [];
        //Cria o regex de funções de agrupamento possíves, que serão implementadas em cryo_Math
        for (var i = 0; i < this.length; i++) {
            functionsPattern.push("(" + this[i] + "\\s*\\(\\s*\\w+\\s*\\))");
        }

        if (addFields) functionsPattern.push(`[a-zA-Z0-9_.]+`);

        return new RegExp(functionsPattern.join("|"), "gi");
    };

    supportedFunctions.getSanitizeRegex = function () {
        var functionsPattern = [];
        //Cria o regex def funções de agrupamento possíves, que serão implementadas em cryo_Math
        for (var i = 0; i < this.length; i++) {
            functionsPattern.push("(" + this[i] + "\\(|\\))");
        }

        return new RegExp(functionsPattern.join("|"), "gi");
    };

    var parseFormula = function (formulaToParse) {
        var result = [];
        var components = [];
        if (formulaToParse === undefined || formulaToParse === '') return result;

        // obter os campos envolvidos em uma formula

        //Regex que pega, em ordem, as ocorrências de SUM com o primeiro pattern "(SUM\s*\(\s*\w+\s*\))" e os identificadores com o segundo
        //pattern "\w{minIdentifierLength,}". Se no futuro necessário adicionar mais funções, adicionar elas a esse regex com um PIPE.
        //let rComponents = /(SUM\s*\(\s*\w+\s*\))|(\w{minIdentifierLength,})/gi
        var rComponents = supportedFunctions.getRegex(true);

        var rComponentsArray = formulaToParse.match(rComponents);

        for (var i = 0; i < rComponentsArray.length; i++) {
            var component = rComponentsArray[i];
            // Filtrar valores numéricos (ex: "0.5", "10", etc.)
            if (!isNaN(component)) continue;

            result.push({ xname: component, type: 'formula' });
        }

        return result;
    };


    var fillDivForHiddenField = function fillDivForHiddenField(sourceField) {
        let hiddenField = sourceField.parentNode.querySelector('div[xid=' + sourceField.getAttribute('xname').replace('inp', 'div') + ']');
        if (hiddenField) 
            hiddenField.innerHTML = sourceField.value;
    };

    
    var parseFormulaAndApplyEvent = function parseFormulaAndApplyEvent(formulaToParse, sourceField, defaultFunctionToRun) {
        var fields = [];
        var functionToRun = defaultFunctionToRun;
        if (formulaToParse === undefined || formulaToParse === '') return false;

        fields = parseFormula(formulaToParse);

        fields.forEach(function (element) {
            var xname = element.xname.replace(supportedFunctions.getSanitizeRegex(), "");

            if (element.type === 'formula') {

                if (functionToRun === undefined) {
                    functionToRun = function (triggeredEvent) {
                        //finding the index inside a table
                        var eventXName = triggeredEvent.target.attributes["xname"].value.replace('inp', '');
                        var i = 0;
                        for (i = 0; i < document.querySelectorAll('[xname=inp' + eventXName + ']').length; i++) {
                            if (document.querySelectorAll('[xname=inp' + eventXName + ']')[i] === triggeredEvent.target) {
                                break;
                            }
                        }

                        cryo_Math(sourceField, formulaToParse, supportedFunctions, i);
                        if (sourceField.getAttribute('type') === 'hidden') {
                            fillDivForHiddenField(sourceField);
                        }
                    };
                }
            }

            blurFields.push("[xname=inp" + xname + "]");

            // atribui funcao matematica a executar no evento blur dos campos envolvidos na formula
            document.querySelectorAll('[xname=inp' + xname + ']').forEach(function (o, i) {
                o.addEventListener('blur', functionToRun);
                o.addEventListener('changeDate', functionToRun);
            });

            // o campo envolvido na formula é calculado a partir de outra formula
            var subformula = document.querySelector('[xname=inp' + xname + ']')?.getAttribute('data-formula');
            if (subformula) {
                // verificar se encontrou campos na subformula
                var fieldsInSubformula = parseFormula(subformula);

                // encontrou campos na subformula
                if (fieldsInSubformula.length > 0) {
                    // deve chamar a mesma funcao no onblur dos campos envolvidos na subformula
                    parseFormulaAndApplyEvent(subformula, sourceField, functionToRun);
                }
            }
        });
    };
    
    var _triggerBlurFields = function (row) {
        fieldsTotal = [];
        getFormulaFieldsOutOfTable(row);
        if (fieldsTotal.length > 0) {
            // Incluído sort com o jquery pois a função "sort()" do js não funciona no IE
            var arraySorted = Array.prototype.slice.call(fieldsTotal).sort(Ascending_sort);
            arraySorted.forEach(function (item, index) {
                var name = item.name;
                var el = document.querySelector('[name="' + name + '"]');

                //Busca o campo que terá a fórmula executada que esteja fora da tabela
                if (el?.closest('table[mult="S"]') == null) {
                    // Obtém o primeiro índice da lista que contém o name e a formula (caso esteja repetido na lista, a fórmula será sempre a mesma pois os identificadores com suas fórmulas são únicos)
                    var obj = fieldsOutOfTable.filter(function (obj) {
                        return obj.name === name;
                    })[0];
                    // Executa fórmula do campo
                    if (obj !== 'undefined') {
                        obj.functionToRun();
                    }
                }
            });
        } else if (blurFields) {
            blurFields.forEach(function (item, index) {
                document.querySelector(item)?.dispatchEvent(new Event('blur'));
            });
        }
    };

    function Ascending_sort(a, b) {
        if (b.currentLevel < a.currentLevel)
            return 1;
        else
            return -1;
    };

    // Obtém os campos do formulário que possuem relação com os campos que foram excluídos da linha da tabela multivalorada
    function getFormulaFieldsOutOfTable(row) {
        var rowFields = [];

        // Obtém todos os inputs contidos na linha
        row?.querySelectorAll('input').forEach(function (o, i) {
            var xname = o.getAttribute('xname');
            // Exclui as letras que formam o "inp"
            rowFields.push(xname.substring(3, xname.length));
        });

        if (rowFields.length > 0) {
            for (var i = 0; i < rowFields.length; i++) {
                findDependencyFieldWithFormula(rowFields[i], 0);
            }
        }
    };

    // Percorre os campos que possuem fórmula e que contenha em sua fórmula, o identificador do campo
    function findDependencyFieldWithFormula(nameFind, dependencyLevel) {
        var currentLevel = dependencyLevel++;
        document.querySelectorAll('[data-formula*="' + nameFind + '"]').forEach(function (element, i) {

            // Apenas seleciona o campo que esteja fora da tabela
            if (element.closest('table[mult="S"]') == null) {
                var name = element.getAttribute('name');
                // Validação para não incluir duplicados
                if (!fieldsTotal.some(function (el, i) { if (el.name === name) { return true; } })) {
                    var xname = element.getAttribute('xname');
                    // Exclui as letras que formam o "inp"
                    xname = xname.substring(3, xname.length);
                    // Executa a função novamente para identificar se o campo de fora da tabela que foi incluído na lista,
                    // não está em um campo com fórmula que não tenha relação com campos da linha excluída
                    findDependencyFieldWithFormula(xname, currentLevel);
                    fieldsTotal.push({ name: name, currentLevel: currentLevel });
                }
            }
        });
    };

    // Lista que guarda o name e fórmula dos campos input
    function addFieldAndFormulaList(formula, sourceField) {
        if (formula === undefined || formula === '') return false;

        var functionToRun = function () {
            cryo_Math(sourceField, formula, supportedFunctions, 0);
            if (sourceField.getAttribute('type') === 'hidden') {
                fillDivForHiddenField(sourceField);
            }
        }

        fieldsOutOfTable.push({ name: sourceField.attributes['name'].value, functionToRun: functionToRun });
    };

    return {

        init: function init() {
            blurFields = [];

            // percorrer todos os campos que possuem o atributo data-formula preenchido
            document.querySelectorAll('[data-formula]').forEach(function (o, i) {
                var formula = o.getAttribute('data-formula');

                // formulas podem conter valores arbitrarios em formato decimal brasileiro
                // deve converter para float
                formula = formula.replace(/\./g, '').replace(/,/g, '.');

                parseFormulaAndApplyEvent(formula, o);

                // Apenas seleciona o campo que esteja fora da tabela multivalorada e inclui na lista
                if (o.closest('table[mult="S"]') == null) {
                    addFieldAndFormulaList(formula, o);
                }
            });
        },

        // adicionar os eventos de calculos matematicos
        addEventsToNewlyAddedRow: function addEventsToNewlyAddedRow() {
            this.init();
        },

        triggerBlurFields: _triggerBlurFields,
        supportedFunctions
    }
};

document.addEventListener("DOMContentLoaded", function () {
    formulaObj = new formula();
    formulaObj.init();
});

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = {
        formula
    };
};